export const DAY_PASS_NAME = 'Day Pass';

export const DAY_PASS_IDS = [
    '6032', // dev/uat
    '290432' // production
];
